import React from 'react';

import { Backdrop } from './styles';

const BackdropComponent = props => (
  <Backdrop onClick={() => props.backdropHandler()} />
);

export default BackdropComponent;
